import { ColumnDef } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { Card, Dropdown, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import axiosInstance from 'utils/axiosInterceptors';
import { TCompanyCustomerDetails } from 'utils/types';
import useAdvanceTable from 'hooks/useAdvanceTable';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import AdvanceTable from 'components/base/AdvanceTable';
import CustomPagination from 'components/pagination/CustomPagination';

type CompanyUsers = {
  userId: number;
  username: string;
  firstName: string;
  lastName: string;
};

const CompanyDetails = () => {
  const { id: companyId } = useParams();
  const [companyDetails, setCompanyDetails] =
    useState<TCompanyCustomerDetails | null>(null); // company details on card
  const [companyUsers, setCompanyUsers] = useState<CompanyUsers[]>([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(5);
  const [totalPages, setTotalPages] = useState(0);

  //function to fetch company details
  const fetchCompanyDetails = async () => {
    try {
      const res = await axiosInstance.get(
        `/api/v1/customers/companies/${companyId}`
      );
      setCompanyDetails(res.data);
      console.log(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  //fetch company users
  const fetchCompanyUsers = async (page: number) => {
    try {
      const res = await axiosInstance.get(
        `/api/v1/customers/companies/${companyId}/users?page=${page}&pageSize=${pageSize}`
      );
      setCompanyUsers(res.data.data);
      setTotalPages(res.data.pageCount);
      console.log(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleSelect = (size: number) => {
    setPageSize(size);
    setCurrentPage(1);
  };

  const columns: ColumnDef<CompanyUsers>[] = [
    {
      id: 'userId',
      header: 'User ID',
      accessorKey: 'userId',
      enableSorting: false
    },
    {
      id: 'username',
      header: 'User Name',
      accessorKey: 'username',
      enableSorting: false
    },
    {
      id: 'firstName',
      header: 'First Name',
      accessorKey: 'firstName',
      enableSorting: false
    },
    {
      id: 'lastName',
      header: 'Last Name',
      accessorKey: 'lastName',
      enableSorting: false
    }
  ];

  const table = useAdvanceTable({
    data: companyUsers,
    columns: columns,
    pageSize: 20,
    pagination: true
  });

  useEffect(() => {
    fetchCompanyDetails();
  }, [companyId]);

  useEffect(() => {
    fetchCompanyUsers(currentPage);
  }, [currentPage, pageSize]);

  return (
    <>
      <Row lg="1" className="mb-3">
        <h4>Company Details</h4>
      </Row>
      <Card className="mb-3">
        <Card.Body className="d-flex">
          <div className="w-50">
            <Card.Title as="h6">
              Company Name: {companyDetails?.companyName}{' '}
            </Card.Title>
            <Card.Title as="h6">Email: {companyDetails?.email} </Card.Title>
            <Card.Title as="h6">
              Contact Number: {companyDetails?.contactNumber}{' '}
            </Card.Title>
            <Card.Title as="h6">
              Membership Number: {companyDetails?.membershipNumber}{' '}
            </Card.Title>
            <Card.Title as="h6">
              Payment Terms: {companyDetails?.paymentTerms}{' '}
            </Card.Title>
          </div>
          <div className="w-50">
            <Card.Title as="h6">
              Address Line 1: {companyDetails?.addressLine1}{' '}
            </Card.Title>
            <Card.Title as="h6">
              Barangay: {companyDetails?.barangay}{' '}
            </Card.Title>
            <Card.Title as="h6">City: {companyDetails?.city} </Card.Title>
            <Card.Title as="h6">
              Province: {companyDetails?.province}{' '}
            </Card.Title>
            <Card.Title as="h6">
              Zip Code: {companyDetails?.zipCode}{' '}
            </Card.Title>
          </div>
        </Card.Body>
      </Card>

      <AdvanceTableProvider {...table}>
        <AdvanceTable
          tableProps={{
            size: 'lg',
            className:
              'phoenix-table fs-9 mb-0 p-5 border-top border-translucent'
          }}
          rowClassName="hover-actions-trigger btn-reveal-trigger position-static"
          bodyClassName="py-3"
        />
      </AdvanceTableProvider>

      <div className="d-flex mt-2 justify-content-end">
        <CustomPagination
          currentPage={currentPage}
          onPageChange={handlePageChange}
          totalPages={totalPages}
        />
        <Dropdown>
          <Dropdown.Toggle variant="phoenix-primary">
            {pageSize}
          </Dropdown.Toggle>
          <Dropdown.Menu className="py-2">
            <Dropdown.Item onClick={() => handleSelect(5)}> 5 </Dropdown.Item>
            <Dropdown.Item onClick={() => handleSelect(10)}> 10 </Dropdown.Item>
            <Dropdown.Item onClick={() => handleSelect(15)}> 15 </Dropdown.Item>
            <Dropdown.Item onClick={() => handleSelect(20)}> 20 </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </>
  );
};

export default CompanyDetails;
